import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCurrentUser } from "./redux/chainsSagas";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { Add } from "./smartComponents/Add";
import { Edit } from "./smartComponents/Edit";
import { Delete } from "./smartComponents/Delete";
import { Trash, Edit as EditIcon } from "../../../assets/images/svg";
import { usePopup } from "../../../hooks/usePopup";
import { WindowVirtualList } from "../../../components/WindowVirtualList/WindowVirtualList";
import "./chains.scss";

function prepareListItems(list, searchValue) {
  const rows = [];
  if (!list) return rows;

  Object.entries(list).forEach(([orgName, currentList]) => {
    const filtered = !searchValue
      ? currentList
      : currentList.filter((el) => el.chainName.toLowerCase().includes(searchValue));

    if (filtered.length > 0) {
      rows.push({ type: "header", orgName });

      filtered.forEach((data) => {
        rows.push({ type: "item", orgName, data });
      });
    }
  });

  return rows;
}

export function ChainsModule({ params }) {
  const dispatch = useDispatch();

  const chains = useSelector((state) => state.chains.chains);
  const isLoading = useSelector((state) => state.chains.isLoading);

  const [selectedChain, setSelectedChain] = useState("");

  const { popup, openPopup, closePopup } = usePopup(["add", "edit", "delete"]);

  const handlePopup = (id, type) => {
    setSelectedChain(id);

    openPopup(type);
  };

  useEffect(() => {
    dispatch(fetchCurrentUser(params));
  }, []);

  if (isLoading)
    return (
      <div className="light">
        <LoadingAnimation />
      </div>
    );

  return (
    <div className="chains">
      <div className="chains__add">
        <button onClick={() => openPopup("add")} className="button button--primary">
          Add New Clubready Chain
        </button>
      </div>

      <div className="chains__content">
        <ul className="group">
          {Object.keys(chains).length ? (
            <WindowVirtualList
              rawItems={chains}
              processItemsFn={prepareListItems}
              estimateSize={() => 53.5}
              renderRow={({ item }) => <Row item={item} handlePopup={handlePopup} />}
            />
          ) : null}
        </ul>
      </div>

      {popup.add && <Add isOpen={popup.add} onClose={closePopup("add")} />}

      {popup.edit && (
        <Edit isOpen={popup.edit} onClose={closePopup("edit")} selectedChain={selectedChain} />
      )}

      <Delete isOpen={popup.delete} onClose={closePopup("delete")} selectedChain={selectedChain} />
    </div>
  );
}

const Row = ({ item: { type, data, orgName }, handlePopup }) => {
  if (type === "header") {
    return <div style={{ fontWeight: "bold", marginBottom: 10, fontSize: "22px" }}>{orgName}</div>;
  }

  let { chainName, uid } = data;

  return (
    <li color="dark" className="group__item">
      <div className="group__el text">{`ID: ${uid} | Chain Name: ${chainName}`}</div>

      <div className="group__el ">
        <span
          className="group__icon"
          onClick={() => handlePopup({ ...data, orgName }, "edit")}
          title="Edit Chain"
        >
          <EditIcon />
        </span>
      </div>

      <div className="group__el delete">
        <span
          className="group__icon"
          onClick={() => handlePopup({ ...data, orgName }, "delete")}
          title="Delete"
        >
          <Trash color="#FF0000" />
        </span>
      </div>
    </li>
  );
};
